import { isProd } from '@library/environment/isomorphic'

export enum ApiKeys {
  DashboardExperience = 'activate/dashboard/v1',
  DashboardExperienceV2 = 'activate/customerengagement/dashboard/v2',
  OrderDeliveryDetails = 'activate/customerengagement/dashboard/order_delivery_details/v1',
}

export type DashboardExperienceApiVersion = 'v1' | 'v2'
export type DashboardExperienceCacheKey = readonly [ApiKeys, DashboardExperienceApiVersion]

export const isDashboardExperienceV2ExperimentEnabled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const isV2ExperimentRequested =
    new URLSearchParams(window.location.search).get('experiment') === 'v2'

  if (!isV2ExperimentRequested) {
    return false
  }

  return !isProd()
}

export const getDashboardExperienceApiVersion = (): DashboardExperienceApiVersion =>
  isDashboardExperienceV2ExperimentEnabled() ? 'v2' : 'v1'

export const getDashboardExperienceApiKey = () => {
  const apiVersion = getDashboardExperienceApiVersion()

  return apiVersion === 'v2' ? ApiKeys.DashboardExperienceV2 : ApiKeys.DashboardExperience
}

export const getDashboardExperienceCacheKey = (): DashboardExperienceCacheKey => {
  const apiVersion = getDashboardExperienceApiVersion()

  return [
    apiVersion === 'v2' ? ApiKeys.DashboardExperienceV2 : ApiKeys.DashboardExperience,
    apiVersion,
  ]
}
